// removed by extract-text-webpack-plugin
module.exports = {"hidden":"R2Z5d","visuallyhidden":"_26kU2","hide-text":"_3qJc7","center":"_1FoN6","noprint":"_37vdT","timestamp":"_3vDfG _25KE7"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-timestamp/styles/feature.scss
 ** module id = 139
 ** module chunks = 2
 **/